import React from 'react';
import Select from 'react-select';

const PropertySelect = ({
  properties,
  adminProperties,
  loadingAdminProperties,
  onChange
}) => {
  return (
    <Select
      value={properties}
      onChange={onChange}
      options={adminProperties.map((adminProperty) => {
        return {
          value: adminProperty.id,
          label: adminProperty.name
        };
      })}
      styles={{
        container: (styles) => ({
          ...styles,
          flex: '1 1 auto'
        })
      }}
      isLoading={loadingAdminProperties}
      closeMenuOnSelect={false}
      isMulti
    />
  );
};

export default PropertySelect;
